import { Component, OnInit } from '@angular/core';
import { NavMenuService } from '@root/modules/common/services/nav-menu.service';
import { CommonService } from '@common/services/common.service';
@Component({
  selector: 'app-home-page',
  templateUrl: './home.page.html',
  styleUrls: ['./home.page.scss'],
})
export class HomePageComponent implements OnInit {
  
  isTransactMenuActive: boolean = false;

  schemeCode: string;

  isNewFundOffer:boolean;


  constructor(
    private navMenuService: NavMenuService,
    private commonService:CommonService
  ) {
    this.getIsTransactTabActive();
  }

  ngOnInit(){
   //
  }

  getIsTransactTabActive() {
    this.navMenuService.getIsTransactTabActive().subscribe((resp) => {
      this.isTransactMenuActive = resp;
    });
  }

  openTransactMenu(data:{isNewFundOffer:boolean, schemeCode?:string}) {
    this.isNewFundOffer = data.isNewFundOffer;
    this.schemeCode = this.isNewFundOffer ?  data.schemeCode : null;
    this.isTransactMenuActive = true;
  }

  closeTransactMenu() {
    this.isTransactMenuActive = false;
  }

}
